import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Gallery from '@/images/Gallery.svg';
import { ImageMediaEntity } from '@/pages/AdvancedEditor/components/panels/media/types';
import { DeleteButton, InfoTag, Loader, TileContainer, TileTitle } from './common';

interface Props {
    entity: ImageMediaEntity;
    width: number;
    height: number;
    onDelete: () => Promise<void>;
    onClick: () => void;
}

export const ImageTile = ({ entity, width, height, onDelete, onClick }: Props) => {
    return (
        <TileContainer width={width} height={height} onClick={entity.isLoading ? undefined : onClick} isLoading={entity.isLoading}>
            {entity.isLoading && <Loader />}
            <DeleteButton className="only-hover" onClick={onDelete} />
            <TileTitle className="only-hover">{entity.filename}</TileTitle>
            <InfoTag content={<MaskedIcon src={Gallery} size="14px" />} />

            <img src={entity.thumbnail} width={width} height={height} />
        </TileContainer>
    );
};
